import React from "react";
import styled from "styled-components";

interface Props {
    children: React.ReactNode
    href: string
}

export const MenuLink: React.FC<Props> = ({ href, children }) => {
  return (
    <Link href={href}>
        {children}
    </Link>
  );
};

const Link = styled.a`
  display: block;
  color: #ffffff;
  font-size: 18px;

  @media (min-width: 768px) {
    padding: 0;
  }

  &:hover {
    color: #E46DD6;
  }
`;